export default "__VITE_ASSET__f17d66c7__"